(function () {
  function parseList(value) {
    if (!value) return [];
    return value.split('||').filter(Boolean);
  }

  class RugCollectionFilters extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById(this.dataset.gridId);
      if (!this.grid) return;

      this.items = Array.from(this.grid.querySelectorAll('.grid__item'));
      this.countEl = document.querySelector('[data-rug-filters-count]');
      this.clearBtn = this.querySelector('[data-rug-filters-clear]');
      this.emptyState = document.querySelector('[data-rug-filters-empty]');
      this.emptyReset = this.emptyState
        ? this.emptyState.querySelector('[data-rug-filters-empty-reset]')
        : null;

      this.addEventListener('change', () => this.apply());

      this.minPriceInput = this.querySelector('[data-rug-filter-price-min]');
      this.maxPriceInput = this.querySelector('[data-rug-filter-price-max]');
      this.minPriceRange = this.querySelector('[data-rug-filter-price-min-range]');
      this.maxPriceRange = this.querySelector('[data-rug-filter-price-max-range]');
      this.sliderRange = this.querySelector('[data-rug-price-range]');

      [this.minPriceInput, this.maxPriceInput].forEach((input) => {
        if (!input) return;
        input.addEventListener('input', () => {
          this.syncSliderFromInputs();
          this.apply();
        });
      });

      [this.minPriceRange, this.maxPriceRange].forEach((range) => {
        if (!range) return;
        range.addEventListener('input', () => {
          this.syncInputsFromSlider();
          this.apply();
        });
      });

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => this.clearAll());
      }

      if (this.emptyReset) {
        this.emptyReset.addEventListener('click', () => this.clearAll());
      }

      this.updateSliderTrack();
      this.apply();
    }

    getChecked(name) {
      return Array.from(this.querySelectorAll('input[name="' + name + '"]:checked')).map(
        (input) => input.value
      );
    }

    syncSliderFromInputs() {
      if (!this.minPriceRange || !this.maxPriceRange) return;
      if (this.minPriceInput.value !== '') this.minPriceRange.value = this.minPriceInput.value;
      if (this.maxPriceInput.value !== '') this.maxPriceRange.value = this.maxPriceInput.value;
      this.updateSliderTrack();
    }

    syncInputsFromSlider() {
      if (!this.minPriceRange || !this.maxPriceRange) return;
      var min = parseFloat(this.minPriceRange.value);
      var max = parseFloat(this.maxPriceRange.value);

      if (min > max) {
        var temp = min;
        min = max;
        max = temp;
      }

      this.minPriceInput.value = min;
      this.maxPriceInput.value = max;
      this.minPriceRange.value = min;
      this.maxPriceRange.value = max;
      this.updateSliderTrack();
    }

    updateSliderTrack() {
      if (!this.minPriceRange || !this.maxPriceRange || !this.sliderRange) return;
      var trackMax = parseFloat(this.minPriceRange.max) || 1;
      var minPercent = (parseFloat(this.minPriceRange.value) / trackMax) * 100;
      var maxPercent = (parseFloat(this.maxPriceRange.value) / trackMax) * 100;
      this.sliderRange.style.left = minPercent + '%';
      this.sliderRange.style.right = 100 - maxPercent + '%';
    }

    clearAll() {
      this.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.checked = false;
      });
      if (this.minPriceInput) this.minPriceInput.value = '';
      if (this.maxPriceInput) this.maxPriceInput.value = '';
      if (this.minPriceRange) this.minPriceRange.value = this.minPriceRange.min;
      if (this.maxPriceRange) this.maxPriceRange.value = this.maxPriceRange.max;
      this.updateSliderTrack();
      this.apply();
    }

    apply() {
      var selectedAvailability = this.getChecked('rug-filter-availability');
      var selectedSizeBuckets = this.getChecked('rug-filter-size-bucket').reduce(
        (all, bucket) => all.concat(parseList(bucket)),
        []
      );
      var selectedColours = this.getChecked('rug-filter-colour');
      var selectedDesigns = this.getChecked('rug-filter-design');

      var minPrice = this.minPriceInput && this.minPriceInput.value !== ''
        ? parseFloat(this.minPriceInput.value)
        : null;
      var maxPrice = this.maxPriceInput && this.maxPriceInput.value !== ''
        ? parseFloat(this.maxPriceInput.value)
        : null;

      var anyActive =
        selectedAvailability.length > 0 ||
        selectedSizeBuckets.length > 0 ||
        selectedColours.length > 0 ||
        selectedDesigns.length > 0 ||
        minPrice !== null ||
        maxPrice !== null;

      if (this.clearBtn) this.clearBtn.hidden = !anyActive;

      var visibleCount = 0;

      this.items.forEach((item) => {
        var itemSizes = parseList(item.dataset.rugSizes);
        var itemColours = parseList(item.dataset.rugColours);
        var itemDesigns = parseList(item.dataset.rugDesigns);
        var itemPrice = parseFloat(item.dataset.rugPrice || '0');
        var itemAvailable = item.dataset.rugAvailable;

        var matches = true;

        if (selectedAvailability.length > 0 && !selectedAvailability.includes(itemAvailable)) {
          matches = false;
        }
        if (matches && selectedSizeBuckets.length > 0 && !selectedSizeBuckets.some((v) => itemSizes.includes(v))) {
          matches = false;
        }
        if (matches && selectedColours.length > 0 && !selectedColours.some((v) => itemColours.includes(v))) {
          matches = false;
        }
        if (matches && selectedDesigns.length > 0 && !selectedDesigns.some((v) => itemDesigns.includes(v))) {
          matches = false;
        }
        if (matches && minPrice !== null && itemPrice < minPrice) {
          matches = false;
        }
        if (matches && maxPrice !== null && itemPrice > maxPrice) {
          matches = false;
        }

        if (matches) {
          item.removeAttribute('data-rug-filtered-out');
          visibleCount += 1;
        } else {
          item.setAttribute('data-rug-filtered-out', '');
        }
      });

      if (this.countEl) {
        this.countEl.textContent =
          visibleCount === this.items.length
            ? this.items.length + (this.items.length === 1 ? ' product' : ' products')
            : 'Showing ' + visibleCount + ' of ' + this.items.length + ' products';
      }

      if (this.emptyState) {
        this.emptyState.classList.toggle('is-visible', visibleCount === 0);
      }
      this.grid.classList.toggle('rug-grid-empty', visibleCount === 0);
    }
  }

  class RugCollectionSort extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.grid = document.getElementById(this.dataset.gridId);
      if (!this.select || !this.grid) return;

      this.items = Array.from(this.grid.querySelectorAll('.grid__item'));
      this.items.forEach((item, index) => {
        item.dataset.rugOriginalIndex = index;
      });

      this.select.addEventListener('change', () => this.sort());
    }

    sort() {
      var value = this.select.value;
      var sorted = this.items.slice();

      switch (value) {
        case 'price-asc':
          sorted.sort((a, b) => parseFloat(a.dataset.rugPrice) - parseFloat(b.dataset.rugPrice));
          break;
        case 'price-desc':
          sorted.sort((a, b) => parseFloat(b.dataset.rugPrice) - parseFloat(a.dataset.rugPrice));
          break;
        case 'title-asc':
          sorted.sort((a, b) => a.dataset.rugTitle.localeCompare(b.dataset.rugTitle));
          break;
        case 'title-desc':
          sorted.sort((a, b) => b.dataset.rugTitle.localeCompare(a.dataset.rugTitle));
          break;
        case 'newest':
          sorted.sort((a, b) => parseInt(b.dataset.rugCreated, 10) - parseInt(a.dataset.rugCreated, 10));
          break;
        default:
          sorted.sort(
            (a, b) => parseInt(a.dataset.rugOriginalIndex, 10) - parseInt(b.dataset.rugOriginalIndex, 10)
          );
      }

      sorted.forEach((item) => this.grid.appendChild(item));
    }
  }

  if (!customElements.get('rug-collection-filters')) {
    customElements.define('rug-collection-filters', RugCollectionFilters);
  }
  if (!customElements.get('rug-collection-sort')) {
    customElements.define('rug-collection-sort', RugCollectionSort);
  }
})();
